import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export const isImg = (dom) => dom.tag === 'img';
export const isAtlassianImg = (dom) => 'data-linked-resource-id' in dom.attributes &&
    'data-linked-resource-container-id' in dom.attributes &&
    'data-width' in dom.attributes &&
    'data-height' in dom.attributes;
export const isHyperlink = (dom) => dom.tag === 'a' && !!dom.attributes && 'href' in dom.attributes;
export const render = (override) => (dom) => {
    var _a;
    if ('value' in dom) {
        return ((_a = override === null || override === void 0 ? void 0 : override.value) === null || _a === void 0 ? void 0 : _a.call(override, dom)) || _jsx(_Fragment, { children: dom.value }, void 0);
    }
    const customRenderer = override === null || override === void 0 ? void 0 : override[dom.tag];
    if (customRenderer) {
        if (isImg(dom))
            return customRenderer(dom);
        if (isHyperlink(dom))
            return customRenderer(dom);
        return customRenderer(dom);
    }
    // default rendering
    const children = _jsx(_Fragment, { children: dom.children.map(render(override)) }, void 0);
    if (['body', 'div'].includes(dom.tag)) {
        return _jsx("div", { children: children }, void 0);
    }
    if (dom.tag === 'span') {
        return _jsx("span", { children: children }, void 0);
    }
    if (dom.tag === 'strong') {
        return _jsx("span", Object.assign({ style: { fontWeight: 700 } }, { children: children }), void 0);
    }
    if (dom.tag === 'em') {
        return _jsx("span", Object.assign({ style: { fontStyle: 'italic' } }, { children: children }), void 0);
    }
    if (dom.tag === 'u') {
        return (_jsx("span", Object.assign({ style: { textDecorationLine: 'underline' } }, { children: children }), void 0));
    }
    if (dom.tag === 'p') {
        return _jsx("p", { children: children }, void 0);
    }
    if (dom.tag === 'li') {
        return _jsx("li", { children: children }, void 0);
    }
    if (dom.tag === 'ul') {
        return _jsx("ul", { children: children }, void 0);
    }
    if (dom.tag === 'ol') {
        return _jsx("ol", { children: children }, void 0);
    }
    if (isImg(dom)) {
        return _jsx("img", Object.assign({}, dom.attributes, { alt: "" }), void 0);
    }
    if (isHyperlink(dom)) {
        return (_jsx("a", Object.assign({ href: dom.attributes.href, target: "_blank", rel: "noreferrer" }, { children: children }), void 0));
    }
    console.debug('unhandled tag:', dom.tag);
    return _jsx(_Fragment, { children: children }, void 0);
};
